import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import { FormControl, Input, InputLabel } from "@mui/material";
import { saveCategory } from "./Services";
import Switch from "@mui/material/Switch";
import MDBox from "../../components/MDBox";

export default function CategoryAdd(props) {

  const {
    showAdd,
    showAddModal,
    fetchCategorySearch
  } = props;
  console.log("ddd" + showAdd);

  const [category, setCategory] = useState({
    name: "",
    isKOT: "",
    isBOT: "",
    description: "",
  });

  const handleOnChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    console.log(name + ":::" + value);
    setCategory({
      ...category,
      [name]: value,
    });

  };

  const setIsKot=(flag)=>{

   setCategory({
     ...category,
     "isKOT":flag
   })
  }

  const setIsBOT=(flag)=>{

    setCategory({
      ...category,
      "isBOT":flag
    })
  }

  const submitCategory = async () => {

    try {
      await saveCategory(category);
      showAddModal(false);
      fetchCategorySearch()
    } catch (e) {
      alert(e.errorMessage);

    }

  };

  const { name, description,isKOT,isBOT } = category;

  return (
    <div>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={showAdd}
        onClose={() => showAddModal(false)}>
        <DialogTitle>Add Category</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Create new Category
          </DialogContentText>

          <Box
            component="form"
            sx={{
              "& > :not(style)": { m: 1 },
            }}
            noValidate
            autoComplete="off"
          >
            <div>
              <FormControl variant="standard">
                <InputLabel htmlFor="component-simple">Name</InputLabel>
                <Input
                  id="component-simple"
                  name={"name"}
                  value={name}
                  onChange={handleOnChange} />
              </FormControl>

            </div>

            <FormControl fullWidth variant="standard">
              <TextField
                id="outlined-textarea"
                label="Description"
                placeholder="Description"
                name={"description"}
                value={description}
                value={description}
                onChange={handleOnChange}
                multiline
                autoSize
              />
            </FormControl>


              <MDBox mt={0.5}>
                <InputLabel htmlFor="component-simple">Is KOT</InputLabel>
                <Switch checked={isKOT} onChange={() => {setIsKot(!isKOT)}} />
              </MDBox>

              <MDBox mt={0.5}>
                <InputLabel htmlFor="component-simple">Is BOT</InputLabel>
                <Switch checked={isBOT} onChange={() => {setIsBOT(!isBOT)}} />
              </MDBox>

          </Box>

        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={() => showAddModal(false)}>Cancel</Button>
          <Button variant="text" onClick={() => submitCategory()}>Create</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
